import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData, SyncData, TripCustomerfetchData } from '../../../apiService';
import { Card, CardContent, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { ThreeDRotationOutlined } from '@material-ui/icons';
import { Discount } from '@mui/icons-material';
import { FaHtml5, FaWeight } from 'react-icons/fa';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios'; // Make sure axios is installed and imported
import ExitToAppIcon from '@mui/icons-material/ExitToApp';



const AdditionalOrderCreate = () => {
  const { id } = useParams();

  const history = useHistory();
  const { isAuthenticated, companyId, userId, customerid, token, logout } = useAuth();

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
    }
  }, [isAuthenticated, token, logout]);

  const [data, setData] = useState(null);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [customerName, setCustomerName] = useState('');
  const [rate, setRate] = useState('');
  const [discount, setDiscount] = useState(''); // Correct 
  const [singlediscount, setsingleDiscount] = useState(''); // Correct capitalization
  const [GSTRate, setGSTRate] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [tripdate, setTripdate] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [qty, setQty] = useState('');
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [CustName, setCustName] = useState("");
  const [SaleRemarks, setSaleRemarks] = useState("");
  const [items, setitems] = useState('');
  const [isReturnsale, setisReturn] = useState('');
  const [Bundle, setBundle] = useState('');
  const [Pieces, setPieces] = useState('');

  const [pricetype, setpricetype] = useState('');
  const [orderDate, setOrderDate] = useState('');
  const [Route, setRoute] = useState("");
  const [routeId, setrouteId] = useState("");

  useEffect(() => {
    fetchtableData();
  }, []);

  const fetchtableData = async () => {
    try {
      const response = await fetchData('RoutePriceTypeApi', `/${id}`, token);

      if (response.responseCode === '1111') {
        setData(response.response_data);

        const Route = response.response_data[0].name;
        const pricetype = response.response_data[0].pricetype;
        const routeId = response.response_data[0].id; // Retrieve routeId
        const orderDate = response.response_data[0].orderDate;

        setpricetype(pricetype);
        setRoute(Route);
        setOrderDate(orderDate);
        setrouteId(routeId);
        console.log(response);

      }
    } catch (error) {
      console.error('Error fetching Item Details:', error);
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  // Function to fetch routes
  const fetchRouteTypes = async () => {
    try {
      const response = await fetchData('RouteApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(route => ({
          value: route.id,
          label: route.name
        }));
        setRouteOptions(options);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
    }
  };

  // Function to handle route change and fetch customers based on selected route
  const handleRouteWiseCustomerChange = async (selectedOption) => {
    setSelectedRoute(selectedOption);
    setSelectedCustomer(null); // Reset customer selection

    try {
      const response = await fetchData('CustomerApi', `/${companyId}/${selectedOption.value}`, token);
      if (response.responseCode === '1111') {
        const customerOptions = response.response_data.map(customer => ({
          value: customer.id,
          label: customer.name + ' ' + customer.addressLine1 + ' ' + customer.customerCode
        }));
        setCustomerOptions(customerOptions);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  // Handle customer selection
  const handleCustomerSelect = (selectedOption) => {
    setSelectedCustomer(selectedOption);
  };

  useEffect(() => {
    fetchRouteTypes();
  }, []);


  // const fetchRouteTypes = async () => {



  const [categoryId, setCategoryId] = useState('');
  const [productCategoryId, setPCategoryId] = useState('');
  const [itemId, setItemId] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [pcategoryOptions, setPCategoryOptions] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPCategory, setSelectedPCategory] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  //Product catgory
  useEffect(() => {
    const fetchPCategoryTypes = async () => {
      try {
        const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);

        if (response.responseCode === '1111') {
          const dataArray = response.response_data;
          const options = response.response_data.map(pcat => ({
            value: pcat.id,
            label: pcat.name
          }));
          setPCategoryOptions(options);
          setPCategoryId(dataArray[0].id);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchPCategoryTypes();
  }, [companyId, token]);

  const handlePCategoryChange = (selectedOption) => {
    setSelectedPCategory(selectedOption);
    fetchCategoryTypes(selectedOption.value);
    // fetchItemsTypes(selectedOption.value);
    setPCategoryId(selectedOption.value);
    setSelectedItem(null);
  };


  //catgory
  const fetchCategoryTypes = async (productCategoryId) => {
    try {
      const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(cat => ({
          value: cat.id,
          label: cat.name
        }));
        setCategoryOptions(options);
        //setCategoryId(dataArray[0].id);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };


  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    fetchItemsTypes(selectedOption.value);
    setCategoryId(selectedOption.value);
    setSelectedItem(null);
  };

  const fetchItemsTypes = async (categoryId) => {
    try {
      const response = await fetchData('ItemApi', `/${companyId}/${categoryId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(item => ({
          value: item.id,
          label: item.name
        }));
        setItemOptions(options);
      }
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const [QtyBundle, setQtyBundle] = useState('');

  const handleItemChange = async (selectedOptions) => {
    setSelectedItem(selectedOptions);
    const ItemID = selectedOptions.value;
    setItemId(ItemID);

    try {
      const response = await fetchData('RoutePriceTypeApi', `/${routeId}/${ItemID}`, token);

      if (response && response.response_data && response.response_data.length > 0) {
        let itemFound = false;

        // Iterate through each category in response_data
        response.response_data.forEach(category => {
          if (category.Items && category.Items.length > 0) {
            category.Items.forEach(item => {
              if (!itemFound) {
                console.log(`Processing item: ${item.Name}`);
                // Process each item here
                // Extract numeric part from Weight

                const { Rate, GSTRate, Weight, Bundle, QtyBundle } = item;
                const numericWeight = parseFloat(Weight);
                setRate(Rate);
                setGSTRate(GSTRate);
                setBundle(Bundle);
                setQtyBundle(QtyBundle);
                setNewItem((prevItem) => ({
                  ...prevItem,
                  weight: numericWeight, // Add weight to the newItem state
                  rate: Rate,
                  GSTRate: GSTRate,
                  //Bundle: Bundle,
                  Bundle: Bundle ?? 0, // Set Bundle to 0 if it's null
                  QtyBundle: QtyBundle ?? 0,
                }));
                itemFound = true; // Set itemFound to true when an item is processed
              }
            });
          }
        });

        if (!itemFound) {
          console.error('No items found in the response data');
        }
      } else {
        console.error('Invalid response structure');
      }
    } catch (error) {
      console.error('Error fetching item rate:', error);
    }
  };


  const [newItem, setNewItem] = useState("");



  const handleQtyChange = (e) => {
    const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (input.length <= 10) { // Limit input length to avoid overflow
      setQty(input); // Update state with cleaned input

      const quantity = parseInt(input) || 0; // Parse input to integer, default to 0 if NaN
      // Calculate other derived values based on your logic
      const gstAmount = (rate * GSTRate) / 100;
      const totalAmount = rate * quantity;
      const totalPlusGst = totalAmount + gstAmount;
      const totalQuantity = newItem.weight * quantity;

      // Update state with the new calculated values
      setNewItem((prevItem) => ({
        ...prevItem,
        quantity: quantity,
        totalAmount: totalAmount,
        GSTRate: GSTRate,
        gstAmount: gstAmount,
        totalPlusGst: totalPlusGst,

        discount: discount,
        totalQuantity: totalQuantity,
      }));
    }
  };



  useEffect(() => {
    const quantity = parseInt(qty) || 0;
    const gstAmount = (rate * GSTRate) / 100;
    const totalAmount = rate * quantity;
    const totalPlusGst = totalAmount + gstAmount;
    const bundle = Bundle;
    //const pieceCount = quantity % newItem.Bundle;
    setNewItem((prevItem) => ({
      ...prevItem,
      rate: rate,
      totalAmount: totalAmount,
      gstAmount: gstAmount,
      totalPlusGst: totalPlusGst,
      discount: discount, // Ensure correct reference
      Bundle: bundle,
      //pieces: pieceCount,
    }));
  }, [rate, qty, discount, GSTRate, Bundle]); // Added dependencies

  const [itemList, setItemList] = useState([]);

  const defaultItem = {
    Id: '',
    Name: '',
    quantity: 1,
    GSTRate: 0,
    rate: 0,
    totalAmount: 0,
    totalPlusGst: 0,
    discount: 0,
    weight: 0,
    totalQuantity: 0,
    rateperkg: 0,
    TotalAmtperkgwise: 0,
    GstPer: 0,
    gstAmount: 0,
    TaxableAmount: 0,
    Bundle: 0,
    Pieces: 0,
    singlediscount: 0,
  };

  const AddtoListdata = (e) => {
    e.preventDefault();
    if (qty > 0) {
      const quantity = parseInt(qty);
      //const bundleSize = parseInt(newItem.Bundle);
      const bundleSize = parseInt(newItem.Bundle) || 0; // Default to 1 if Bundle is null or 0
      const discountPerPiece = newItem.discountPerPiece || 0; // Default to 0 if DiscountPerPiece is null or undefined
      const discount = parseInt(discountPerPiece) || 0;
      // Calculate number of bundles and remaining pieces
      // Check if bundleSize is valid (not null or 0)
      const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
      const pieceCount = bundleSize ? quantity % bundleSize : 0;

      let RateAfterDiscount = 0;

      if (discount > 0) {
        RateAfterDiscount = rateperkg - discount;
      }
      else {
        RateAfterDiscount = rate;
      }
      // Your existing calculations
      // const rateperkg = rate / newItem.weight;
      const rateperkg = rate;
      const totalQuantity = newItem.weight * quantity;
      const totalAmount = rate * quantity;
      const TotalAmtperkgwise = rateperkg * totalQuantity;
      const TaxableAmount = ((rateperkg - discount) * totalQuantity * 100) / (100 + GSTRate);
      const gstAmount = (TaxableAmount * GSTRate) / 100;
      const GstPer = (gstAmount / TaxableAmount) * 100;
      const totalPlusGst = TaxableAmount + gstAmount;

      const updatedItem = {
        ...newItem,
        Name: selectedItem.label,
        Id: selectedItem.value,
        quantity: quantity,
        rate: rate,
        GSTRate: GSTRate,
        totalAmount: totalAmount,
        totalPlusGst: totalPlusGst,
        discount: discount,
        totalQuantity: totalQuantity,
        rateperkg: rateperkg,
        TotalAmtperkgwise: TotalAmtperkgwise,
        TaxableAmount: TaxableAmount,
        gstAmount: gstAmount,
        GstPer: GstPer,
        Bundle: numBundles,
        Pieces: pieceCount,
        QtyBundle: QtyBundle,
      };

      // Updating state
      setItemList([...itemList, updatedItem]);

      // Resetting newItem state
      setNewItem({
        Id: '',
        Name: '',
        quantity: 1,
        GSTRate: 0,
        rate: 0,
        totalAmount: 0,
        totalPlusGst: 0,
        discount: 0,
        weight: 0,
        totalQuantity: 0,
        rateperkg: 0,
        TotalAmtperkgwise: 0,
        GstPer: 0,
        gstAmount: 0,
        TaxableAmount: 0,
        Bundle: 0,
        pieces: 0,
      });

      // Resetting other state variables
      setNewItem({ ...defaultItem });
      setSelectedItem('');
      setQty('');
      setRate('');
      setGSTRate(0);
      setBundle('');
    }
  };
  const handleDiscountChange = (e, index) => {
    const value = parseFloat(e.target.value) || 0;
    const updatedItems = [...itemList];
    updatedItems[index].singlediscount = value;

    const TotalQuantity = updatedItems[index].totalQuantity || 0;
    const rateperkg = updatedItems[index].rateperkg || 0;
    const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
    const TotalAmtperkgwise = rateperkg * TotalQuantity;
    const TaxableAmount = (((rateperkg - value) * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0;
    const gstAmount = (TaxableAmount * updatedItems[index].GSTRate / 100) || 0;
    const GstPer = (TaxableAmount !== 0) ? (gstAmount / TaxableAmount * 100) : 0;
    const totalPlusGst = TaxableAmount + gstAmount;

    updatedItems[index].totalPlusGst = totalPlusGst;
    updatedItems[index].discount = value;
    updatedItems[index].gstAmount = gstAmount;
    updatedItems[index].GstPer = GstPer;
    updatedItems[index].TaxableAmount = TaxableAmount;
    setItemList(updatedItems);
  };



  const handleQuantityChange = (e, index) => {
    const { value } = e.target;
    const updatedItems = [...itemList];
    const quantity = parseInt(value, 10);
    updatedItems[index].quantity = quantity;

    let bundleSize = 0;
    const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
    const bag = updatedItems[index].BagWeight || 0;
    const bagweight = updatedItems[index].weight || 0;
    let BagWeight = 0;

    if (bag > 0) {
      BagWeight = bag;
      bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
    } else if (bagweight > 0) {
      BagWeight = bagweight;
      bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;
    }

    const rateperkg = updatedItems[index].rateperkg || 0;

    const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
    const pieceCount = bundleSize ? quantity % bundleSize : 0;

    // Calculate Total Quantity (Kgs)
    const TotalQuantity = BagWeight * quantity;
    updatedItems[index].totalQuantity = TotalQuantity;

    const RateAfterDiscount = rateperkg - DiscountPerPiece;
    updatedItems[index].RateAfterDiscount = RateAfterDiscount;

    const TaxableAmount = ((RateAfterDiscount * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0;
    updatedItems[index].TaxableAmount = TaxableAmount;

    const gstAmount = (TaxableAmount * updatedItems[index].GSTRate / 100) || 0;
    updatedItems[index].gstAmount = gstAmount;

    const totalPlusGst = TaxableAmount + gstAmount;
    updatedItems[index].totalPlusGst = totalPlusGst;

    const totalAmount = RateAfterDiscount * quantity;
    updatedItems[index].totalAmount = totalAmount;

    updatedItems[index].Bundle = numBundles;
    updatedItems[index].Pieces = pieceCount;

    console.log("Updated Item:", updatedItems[index]); // Debug log to check updated values

    setItemList(updatedItems); // This should trigger a re-render with the updated state
  };



  const submitData = async (e) => {
    e.preventDefault();
    try {
      const itemsToSave = itemList.map(item => ({
        ItemId: item.Id,
        // CustomerId: customerId || 0, // Ensure CustomerId is set to 0 if not provided
        CustomerId: selectedCustomer?.value || 0, // Using selectedCustomer value
        CompanyId: companyId,
        CategoryId: categoryId,
        ProductCategoryId: productCategoryId,
        rate: item.Rate,

        Quantity: item.quantity,
        Discount: item.discount ? item.discount : 0,
        BilledDate: new Date(),
        CreatedBy: userId,
        CreatedDate: new Date(),
        RatePerKg: item.rateperkg,
        DiscountPerPiece: item.singlediscount ? item.singlediscount : 0,
        RateAfterDiscount: (item.rateperkg - item.singlediscount),
        TotalQty: item.totalQuantity,
        BagWeight: item.weight,
        CGSTAmt: (item.gstAmount / 2),
        SGSTAmt: (item.gstAmount / 2),
        GSTAmt: item.gstAmount,
        TaxableAmt: item.TaxableAmount,
        NetAmt: item.totalPlusGst,
        Bundle: item.Bundle,
        Pieces: item.Pieces

      }));

      const saleorderdata = {
        TripId: id,
        CustomerId: selectedCustomer?.value || 0, // Using selectedCustomer value
        OrderDate: orderDate,
        SaleRemarks: SaleRemarks,
        RId: selectedRoute.value,
        RName: selectedRoute.label,
        CreatedBy: userId,
        CompanyId: companyId,
        CreatedDate: new Date(),
        OrderType: 2,
        CustName: CustName,
      };

      const CreateData = {
        SaleOrder: saleorderdata,
        SaleOrderDetails: itemsToSave,
      };

      // Show a confirmation dialog before submitting the order
      const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
      if (confirmOrder) {
        postData('AddOrderAPI', CreateData, token)
          .then((response) => {
            if (response.response === '1111') {
              const SaleOrderid = response.SaleOrderId;
              history.push(`/TriporderedIndexs/${id}`);
            }
          })
          .catch((error) => {
            console.error('SaleOrder Create error:', error);
          });
      }
    } catch (error) {
      console.error('Submit error:', error);
    }
  };

  const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const openConfirmDialog = (index) => {
    setItemToDeleteIndex(index);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setItemToDeleteIndex(null);

  };

  const handleDelete = () => {
    if (itemToDeleteIndex !== null) {
      const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
      setItemList(updatedItemList);
      closeConfirmDialog();
    }
  };
  const handleRateChange = (e, index) => {
    const newRate = parseFloat(e.target.value) || 0;

    // Update the item at the specified index
    setItemList((prevItemList) => {
      return prevItemList.map((item, i) => {
        if (i === index) {
          const quantity = item.quantity;
          const totalQuantity = item.weight * quantity;
          const totalAmount = newRate * totalQuantity;

          const TaxableAmount = ((newRate - item.singlediscount) * totalQuantity * 100) / (100 + item.GSTRate);
          const gstAmount = (TaxableAmount * item.GSTRate) / 100;
          const totalPlusGst = TaxableAmount + gstAmount;

          return {
            ...item,
            rateperkg: newRate,
            totalQuantity: totalQuantity,
            TaxableAmount: TaxableAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            TotalAmtperkgwise: totalAmount,
            GstPer: item.GSTRate,
          };
        }
        return item;
      });
    });
  };

  return (

    <div style={{ maxWidth: '100%', backgroundColor: '#f0f7f4', padding: '16px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
      <div style={{ backgroundColor: 'white', padding: '16px', borderRadius: '8px' }}>

        <form onSubmit={submitData}>

          {/* Header Section */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #6b4c7a' }}>
            <div>
              <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#6b4c7a', fontFamily: 'Arial, sans-serif', textTransform: 'uppercase' }}>
                Additional Order
              </h2>
              <div style={{ display: 'flex', gap: '20px', marginTop: '8px', fontSize: '13px', color: '#2c3e50' }}>
                <span><strong>Route:</strong> {Route}</span>
                <span><strong>Order Date:</strong> {orderDate && new Date(orderDate).toLocaleDateString('en-GB')}</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button
                variant="contained"
                type="submit"
                style={{
                  minWidth: '120px',
                  height: '36px',
                  fontSize: '12px',
                  backgroundColor: '#10a37f',
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '18px',
                  textTransform: 'none'
                }}
              >
                Order Confirm
              </Button>

              <Tooltip title="Back To List">
                <Link to={`/AddtionalOrderIndex/${id}`} style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    color="error"
                    style={{
                      height: '36px',
                      fontSize: '12px',
                      borderRadius: '18px',
                      textTransform: 'none'
                    }}
                  >
                    Back <ExitToAppIcon style={{ marginLeft: '4px', fontSize: '18px' }} />
                  </Button>
                </Link>
              </Tooltip>
            </div>
          </div>

          {/* Customer Selection Section */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                Route <span style={{ color: '#dc3545' }}>*</span>
              </label>
              <Select
                value={selectedRoute}
                onChange={handleRouteWiseCustomerChange}
                options={routeOptions}
                placeholder="Select Route"
                isSearchable
                styles={{
                  control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                  option: (base) => ({ ...base, fontSize: '13px' })
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                Customer <span style={{ color: '#dc3545' }}>*</span>
              </label>
              <Select
                options={customerOptions}
                value={selectedCustomer}
                onChange={handleCustomerSelect}
                placeholder="Select a Customer"
                isSearchable
                styles={{
                  control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                  option: (base) => ({ ...base, fontSize: '13px' })
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                Customer Name
              </label>
              <input
                value={CustName}
                onChange={(e) => setCustName(e.target.value)}
                type="text"
                placeholder="Enter customer name"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  fontSize: '13px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  height: '36px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                Remarks
              </label>
              <input
                value={SaleRemarks}
                onChange={(e) => setSaleRemarks(e.target.value)}
                type="text"
                placeholder="Enter remarks"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  fontSize: '13px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  height: '36px'
                }}
              />
            </div>
          </div>

          {/* Product Selection Section */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'flex-end' }}>
            <div style={{ flex: '1' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                Category
              </label>
              <Select
                value={selectedPCategory}
                onChange={handlePCategoryChange}
                options={pcategoryOptions}
                placeholder="Select Category"
                isSearchable
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                  option: (base) => ({ ...base, fontSize: '13px' }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 })
                }}
              />
            </div>

            <div style={{ flex: '1' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                Variant
              </label>
              <Select
                value={selectedCategory}
                onChange={handleCategoryChange}
                options={categoryOptions}
                placeholder="Select Variant"
                isSearchable
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                  option: (base) => ({ ...base, fontSize: '13px' }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 })
                }}
              />
            </div>

            <div style={{ flex: '1' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                Variant with Bagweight
              </label>
              <Select
                value={selectedItem}
                onChange={handleItemChange}
                options={itemOptions}
                placeholder="Select Item"
                isSearchable
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                  option: (base) => ({ ...base, fontSize: '13px' }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 })
                }}
              />
            </div>

            <div style={{ flex: '0 0 150px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '6px' }}>
                QTY (No.of pieces)
              </label>
              <input
                value={qty}
                onChange={handleQtyChange}
                type="text"
                placeholder="Quantity"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  fontSize: '13px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  height: '36px'
                }}
              />
            </div>

            <div style={{ flex: '0 0 auto' }}>
              <Button
                variant="contained"
                onClick={AddtoListdata}
                style={{
                  height: '36px',
                  fontSize: '12px',
                  backgroundColor: '#10a37f',
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '18px',
                  textTransform: 'none',
                  padding: '0 20px'
                }}
              >
                Add Item
              </Button>
            </div>
          </div>



          {/* <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '400px', overflowY: 'auto' }}> */}

          <div style={{ marginTop: '16px', maxHeight: '500px', overflowY: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' }}>
            <TableContainer component={Paper}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#6b4c7a' }}>
                  <tr>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Sl.No</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'left', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Name</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                      Qty<br /><span style={{ fontSize: '10px' }}>(No.Pieces)</span>
                    </th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                      Total Qty<br /><span style={{ fontSize: '10px' }}>(Kgs)</span>
                    </th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Bundle</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Pieces</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                      Rate/Kg<br /><span style={{ fontSize: '10px' }}>(Including Tax)</span>
                    </th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Discount</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>
                      Rate<br /><span style={{ fontSize: '10px' }}>(After Discount)</span>
                    </th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Taxable Amt</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'center', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>GST%</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>GST (₹)</th>
                    <th style={{ color: 'white', fontWeight: 700, fontSize: '12px', padding: '8px 6px', textAlign: 'right', whiteSpace: 'nowrap' }}>Total</th>
                  </tr>
                </thead>

                {/* <tbody>
                  {itemList.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white', borderBottom: '1px solid #dee2e6' }}>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>{index + 1}</td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'left', fontWeight: 'bold', borderRight: '1px solid #dee2e6' }}>{item.Name}</td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>
                        <input
                          type="number"
                          value={item.quantity}
                          onChange={(e) => handleQuantityChange(e, index)}
                          style={{ width: '100%', maxWidth: '80px', textAlign: 'right', padding: '4px', fontSize: '11px', border: '1px solid #ddd', borderRadius: '4px' }}
                          min="0"
                          step="1"
                        />
                      </td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6' }}>{item.totalQuantity}</td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>{item.Bundle}</td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>{item.Pieces}</td>

                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'right', borderRight: '1px solid #dee2e6' }}>
                        <input
                          type="number"
                          value={item.rateperkg}
                          onChange={(e) => handleRateChange(e, index)}
                          style={{ width: '100%', maxWidth: '90px', textAlign: 'right', padding: '4px', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px' }}
                          step="0.01"
                          min="0"
                        />
                      </td>

                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'right', borderRight: '1px solid #dee2e6' }}>
                        <input
                          type="number"
                          value={(isNaN(item.singlediscount) || item.singlediscount === "") ? '0' : item.singlediscount}
                          onChange={(e) => handleDiscountChange(e, index)}
                          style={{ width: '100%', maxWidth: '70px', textAlign: 'right', padding: '4px', fontSize: '11px', border: '1px solid #ddd', borderRadius: '4px' }}
                          step="0.01"
                          min="0"
                        />
                      </td>

                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6' }}>
                        {((item.singlediscount ?? 0) === 0
                          ? item.rateperkg
                          : (item.rateperkg - item.singlediscount)
                        ).toFixed(2)}
                      </td>

                      <td style={{ fontSize: '12pxpx', padding: '6px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6' }}>
                        {(isNaN((item.TaxableAmount)) || ((item.TaxableAmount)) === "")
                          ? (item.TaxableAmount).toFixed(2)
                          : ((item.TaxableAmount)).toFixed(2)}
                      </td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>{item.GSTRate}</td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6' }}>{item.gstAmount.toFixed(2)}</td>
                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'right', fontFamily: 'monospace', borderRight: '1px solid #dee2e6' }}>{((item.totalPlusGst)).toFixed(2)}</td>

                      <td style={{ fontSize: '12px', padding: '6px', textAlign: 'center' }}>
                        <Tooltip title="Delete">
                          <DeleteIcon
                            style={{ color: '#dc3545', cursor: 'pointer', fontSize: '18px' }}
                            onClick={() => openConfirmDialog(index)}
                          />
                        </Tooltip>
                      </td>
                    </tr>
                  ))}


                </tbody> */}

                <tbody>
                  {itemList.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                        borderBottom: '1px solid #dee2e6'
                      }}
                    >
                      {/* SL NO */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'center',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {index + 1}
                      </td>

                      {/* NAME */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'left',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {item.Name}
                      </td>

                      {/* QUANTITY INPUT */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'center',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        <input
                          type="number"
                          value={item.quantity}
                          onChange={(e) => handleQuantityChange(e, index)}
                          style={{
                            width: '100%',
                            maxWidth: '80px',
                            textAlign: 'right',
                            padding: '4px',
                            fontSize: '13px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontFamily: 'Arial'
                          }}
                          min="0"
                          step="1"
                        />
                      </td>

                      {/* TOTAL QTY */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'right',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {item.totalQuantity}
                      </td>

                      {/* BUNDLE */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'center',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {item.Bundle}
                      </td>

                      {/* PIECES */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'center',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {item.Pieces}
                      </td>

                      {/* RATE */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'right',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        <input
                          type="number"
                          value={item.rateperkg}
                          onChange={(e) => handleRateChange(e, index)}
                          style={{
                            width: '100%',
                            maxWidth: '90px',
                            textAlign: 'right',
                            padding: '4px',
                            fontSize: '13px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontFamily: 'Arial'
                          }}
                          step="0.01"
                          min="0"
                        />
                      </td>

                      {/* DISCOUNT */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'right',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        <input
                          type="number"
                          value={(isNaN(item.singlediscount) || item.singlediscount === "") ? '0' : item.singlediscount}
                          onChange={(e) => handleDiscountChange(e, index)}
                          style={{
                            width: '100%',
                            maxWidth: '70px',
                            textAlign: 'right',
                            padding: '4px',
                            fontSize: '13px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontFamily: 'Arial'
                          }}
                          step="0.01"
                          min="0"
                        />
                      </td>

                      {/* NET RATE */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'right',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {(
                          (item.singlediscount ?? 0) === 0
                            ? item.rateperkg
                            : (item.rateperkg - item.singlediscount)
                        ).toFixed(2)}
                      </td>

                      {/* TAXABLE AMT */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'right',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {isNaN(item.TaxableAmount)
                          ? item.TaxableAmount
                          : item.TaxableAmount.toFixed(2)}
                      </td>

                      {/* GST % */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'center',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {item.GSTRate}
                      </td>

                      {/* GST AMOUNT */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'right',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {item.gstAmount.toFixed(2)}
                      </td>

                      {/* TOTAL + GST */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'right',
                          borderRight: '1px solid #dee2e6'
                        }}
                      >
                        {item.totalPlusGst.toFixed(2)}
                      </td>

                      {/* DELETE */}
                      <td
                        style={{
                          fontSize: '14px',
                          fontFamily: 'Arial',
                          padding: '6px',
                          textAlign: 'center'
                        }}
                      >
                        <Tooltip title="Delete">
                          <DeleteIcon
                            style={{ color: '#dc3545', cursor: 'pointer', fontSize: '18px' }}
                            onClick={() => openConfirmDialog(index)}
                          />
                        </Tooltip>
                      </td>
                    </tr>
                  ))}
                </tbody>



                <tfoot>
                  <tr style={{ backgroundColor: '#fff3cd', fontWeight: 'bold' }}>
                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'left', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }} colSpan="2">
                      Total
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'center', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + item.quantity, 0)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'right', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + item.totalQuantity, 0)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'center', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + item.Bundle, 0)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'center', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + item.Pieces, 0)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'right', borderRight: '1px solid #dee2e6', fontFamily: 'Arial' }}></td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'right', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + (Number(item.singlediscount) || 0), 0).toFixed(2)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'right', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => {
                        const ratePerKg = Number(item.rateperkg) || 0;
                        const singleDiscount = Number(item.singlediscount) || 0;
                        return acc + (ratePerKg - singleDiscount);
                      }, 0).toFixed(2)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'right', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + item.TaxableAmount, 0).toFixed(2)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'center', borderRight: '1px solid #dee2e6', fontFamily: 'Times New Roman' }}></td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'right', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + item.gstAmount, 0).toFixed(2)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'right', borderRight: '1px solid #dee2e6', fontWeight: 'bold', fontFamily: 'Arial' }}>
                      {itemList.reduce((acc, item) => acc + item.totalPlusGst, 0).toFixed(2)}
                    </td>

                    <td style={{ fontSize: '14px', padding: '8px', textAlign: 'center', fontFamily: 'Arial' }}></td>
                  </tr>
                </tfoot>


              </table>
              <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete this record?
                  </DialogContentText>
                </DialogContent>

                <DialogActions>
                  <button
                    onClick={closeConfirmDialog}
                    style={{
                      backgroundColor: '#dc3545',
                      color: '#ffffff',
                      border: '1px solid #dc3545',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      marginRight: '8px',
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleDelete(itemToDeleteIndex)}
                    style={{
                      backgroundColor: '#28a745',
                      color: '#ffffff',
                      border: '1px solid #28a745',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                    }}
                  >
                    Confirm
                  </button>
                </DialogActions>

              </Dialog>
            </TableContainer>
          </div>

        </form>
      </div>
    </div>
  );
};

export default AdditionalOrderCreate;
